import { render } from "./MainConfig.vue?vue&type=template&id=8fcd4240"
import script from "./MainConfig.vue?vue&type=script&lang=js"
export * from "./MainConfig.vue?vue&type=script&lang=js"

import "./MainConfig.vue?vue&type=style&index=0&id=8fcd4240&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__